<template lang="pug">
  b-container(fluid)
    b-row
      b-col.mb-5(cols="12")
        b-row
          b-col(md="6")
            p.mb-2 Color del Chat de tu tienda en línea y botón flotante:
            b-img.pointer(width="35", height="35", blank, :blank-color="chatbot_data.color || '#f2f2f2'", v-b-tooltip.hover, title="Cambiar color", rounded, id="color_picker_popover", style="border:1px dashed #ddd;")
            span.mx-3.text-secondary {{ chatbot_data.color || '#f2f2f2' }}

            p.mb-2 Color de los mensajes de usuario:
            b-img.pointer(width="35", height="35", blank, :blank-color="chatbot_data.user_message_color || '#f2f2f2'", v-b-tooltip.hover, title="Cambiar color", rounded, id="color_message_picker_popover", style="border:1px dashed #ddd;")
            span.mx-3.text-secondary {{ chatbot_data.user_message_color || '#f2f2f2' }}

      b-col.mb-5(cols="12")
        b-row
          b-col(md="6")
            b-form-group(label="Saludo de bienvenida:")
              b-form-input(placeholder="¡Hola!", v-model="chatbot_data.greetings")

            b-form-group(label="Mensaje de bienvenida:")
              b-form-input(placeholder="Selecciona una respuesta rápida o escribe un mensaje para comenzar.", v-model="chatbot_data.welcome_msg")
          
          b-col.d-none.d-md-block(cols="6")
            b-card.no-shadow.py-5.px-2.bottom-top-gradient(no-body, :style="{'background-color': chatbot_data.color, color: BWTextColor(chatbot_data.color)}", style="border-bottom: none;border-bottom-left-radius: 0;border-bottom-right-radius: 0;")
              h1.mb-2 {{ chatbot_data.greetings || '¡Hola!' }}
              p.mb-4 {{ chatbot_data.welcome_msg || 'Selecciona una respuesta rápida o escribe un mensaje para comenzar.' }}

      b-col.mb-5(cols="12")
        b-row
          b-col(md="6")
            b-form-group(label="Nombre del Chat de tu tienda en línea como aparece en la cabecera del chat:")
              b-form-input(placeholder="Nombre del Bot", v-model="chatbot_data.name")
            b-form-group(label="Descripción. Frase que aparecerá debajo del nombre del Chat:")
              b-form-input(placeholder="Descripción", v-model="chatbot_data.description")

            b-form-row
              b-col
                p.mb-2 Imagen de perfil:
                b-img.pointer.bg-light(width="125", height="125", :blank="!chatbot_data.image", blank-color="#f2f2f2", :src="chatbot_data.image", v-b-tooltip.hover, :title="chatbot_data.image ? 'Cambiar imagen' : 'Subir imagen'", rounded, @click="$refs.input_image.click()", style="border:1px dashed #ddd;")
                p.mb-0.text-sm
                  b-link.text-danger(v-if="chatbot_data.image", @click="chatbot_data.image = ''") Quitar imagen
                input(type="file", accept="image/*", style="display:none;", ref="input_image", @change="imagePicked($event, 'image')")
              b-col.text-center
                b-form-group(label="Powered by Artificial Nerds")
                  b-form-checkbox(switch, v-model="chatbot_data.show_brand") {{chatbot_data.show_brand ? 'Mostrar' : 'Ocultar'}}

          
          b-col.d-none.d-md-block(cols="6")
            b-card.no-shadow.bottom-top-gradient.pb-5(no-body, style="border-bottom: none;border-bottom-left-radius: 0;border-bottom-right-radius: 0;")
              .transparent.chat-header.d-flex.align-items-center(:style="{'background-color': chatbot_data.color, color: BWTextColor(chatbot_data.color)}", style="border-top-right-radius:5px;border-top-left-radius:5px;")
                b-container
                  b-row.flex-nowrap.align-items-center(no-gutters)
                    b-col(cols="auto")
                      .big-button
                        chevron-left-icon(:style="{color: BWTextColor(chatbot_data.color)}", style="width:27px;height:27px;")
                    b-col.px-2(cols="auto")
                      b-img.agent-picture-head(:src="chatbot_data.image", rounded="circle", :blank="!chatbot_data.image", blank-color="#ccc", v-if="chatbot_data.image", height="40", width="40")
                    b-col.d-flex.justify-content-center.flex-column(style="padding-right:30px;")
                      h2.d-inline-block.m-0.text-truncate(:style="{color: BWTextColor(chatbot_data.color)}") {{ chatbot_data.name }}
                      p.d-inline-block.m-0.text-truncate(:style="{color: BWTextColor(chatbot_data.color)}") {{ chatbot_data.description }}

      b-col.mb-5(cols="12")
        b-row
          b-col(md="6")
            p.mb-2 Ícono de botón flotante:
            b-img.pointer.bg-light(width="75", height="75", :blank="!chatbot_data.icon", blank-color="#f2f2f2", :src="chatbot_data.icon", v-b-tooltip.hover, :title="chatbot_data.icon ? 'Cambiar imagen' : 'Subir imagen'", rounded, @click="$refs.input_icon.click()", style="border:1px dashed #ddd;")
            p.mb-0.text-sm
              b-link.text-danger(v-if="chatbot_data.icon", @click="chatbot_data.icon = ''") Quitar ícono
            input(type="file", accept="image/*", style="display:none;", ref="input_icon", @change="imagePicked($event, 'icon')")
          
          b-col.d-none.d-md-block(cols="6")
            .b-m-button(:style="{'background-color': chatbot_data.color}")
              img.b-m-button-icon(:src="chatbot_data.icon", v-if="chatbot_data.icon")
              img.b-m-button-icon(:src="require(`@/assets/icons/chat-${BWTextColor(chatbot_data.color)}.png`)", v-else)


    b-button.mb-3(variant="primary", @click="updateChatbotConfig", :disabled="loading", block) Guardar configuración
    b-popover(target="color_picker_popover", triggers="click blur", placement="top", custom-class="color-picker-popover")
      color-picker(:value="chatbot_data.color", @input="chatbot_data.color = $event.hex", key="widget-color")
    b-popover(target="color_message_picker_popover", triggers="click blur", placement="top", custom-class="color-picker-popover")
      color-picker(:value="chatbot_data.user_message_color", @input="chatbot_data.user_message_color = $event.hex", key="widget-color")
</template>

<script>
  import { createNamespacedHelpers, mapActions } from 'vuex'
  import { Sketch } from 'vue-color'
  import { UploadFile } from '@/helpers/upload-file'
  import { toBase64 } from '@/helpers/file-converter'
  import { BWTextColor } from '@/helpers/contrast-color-generator'

  export default {
    data () {
      return {
        loading: false,
        bmessaging_id: null,
        show_colors: false,
        chatbot_data: {
          name: '',
          image: '',
          color: '',
          icon: '',
          greetings: '',
          welcome_msg: '',
          description: '',
          user_message_color: '',
          show_brand: true
        },
        file_image: null,
        file_icon: null,
      }
    },
    props: {
      model_id: {
        default: null
      },
      chatbot: {
        default: null
      }
    },
    methods: {
      BWTextColor: BWTextColor,
      ...mapActions(['helpers/upload_file', 'bmessaging/get_bmid', 'bmessaging/update']),
      getBmessaging () {
        let self = this
        this.loading = true

        this['bmessaging/get_bmid']({
          account_id: self.$route.params.account_id,
          model_id: self.model_id,
          callback: res => {
            console.log(res);
            self.loading = false
            if (res.error) {
              self.$message.error(res.error)
            } else {
              let account = res.resource.find(a => a.bmessaging_id == self.model_id)
              if(account) {
                self.bmessaging_id = account.bmessaging_id
                self.chatbot_data = Object.assign(self.chatbot_data, account)
                self.chatbot_data.color = account.color || '#DDDDDD'
                self.chatbot_data.user_message_color = account.user_message_color || '#DDDDDD'
              }
            }
          }
        })
      },
      imagePicked (event, key) {
        let file = event.target.files[0]
        this['file_' + key] = file
        this.chatbot_data[key] = URL.createObjectURL(file)
        this.$refs.input_image.value = ''
        this.$refs.input_icon.value = ''
      },
      async updateChatbotConfig () {
        let self = this
        this.loading = true

        if (this.file_image) {
          try {
            this.chatbot_data.image = await UploadFile.call(this, this.file_image)
          } catch (e) {
            console.log(e)
            this.chatbot_data.image = ''
            this.loading = false
            this.$message.warning('No logramos subir la imagen, por favor comprueba tu conexión a internet')
            return
          }
        }

        if (this.file_icon) {
          try {
            this.chatbot_data.icon = await UploadFile.call(this, this.file_icon)
          } catch (e) {
            console.log(e);
            this.chatbot_data.icon = ''
            this.loading = false
            this.$message.warning('No logramos subir el ícono, por favor comprueba tu conexión a internet')
            return
          }
        }

        this['bmessaging/update']({
          account_id: self.$route.params.account_id,
          bmessaging_id: self.bmessaging_id,
          ...self.chatbot_data,
          callback: res => {
            self.loading = false
            if (res.error) {
              self.$message.error(res.error)
            } else {
              self.show_colors = false
              self.$emit('update', this.chatbot_data.name)
              self.$message.success('Configuración actualizada')
            }
          }
        })
      },
      async uploadFile (file) {
        let self = this
        return new Promise (async (resolve, reject) => {
          let params = {
            file_name: file.name,
            mime: file.type
          }

          try {
            if (file.name.includes('.'))
              params.file_extension = file.name.split('.').slice(-1)
          } catch (e) {
            console.log(e.message)
          }

          try {
            let fileBase64 = await toBase64(file, true)
            params.file = fileBase64
          } catch (e) {
            console.log(e.message)
            reject(new Error('Error cargando archivo'))
          }

          self['helpers/upload_file']({
            ...params,
            callback: res => {
              if (res.error) {
                reject(new Error(res.error))
              } else {
                resolve(res.resource.url)
              }
            }
          })
        })
      },
    },
    mounted () {
      if(this.model_id){
        this.getBmessaging()
      } else if(this.chatbot) {
        this.bmessaging_id = this.chatbot.bmessaging_id
        this.chatbot_data = Object.assign(this.chatbot_data, this.chatbot)
        this.chatbot_data.color = this.chatbot.color || '#DDDDDD'
      }
    },
    components: {
      'color-picker' : Sketch,
      role () {
        return this.$getCookie('user')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .color-picker-popover {
    min-width: 244px !important;
    max-width: 244px !important;
  }

  .bottom-top-gradient {
    background: -moz-linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 80%, rgba(249,251,253,1) 100%);
    background: -webkit-linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 80%, rgba(249,251,253,1) 100%);
    background: linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 80%, rgba(249,251,253,1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#ffffff",endColorstr="#f9fbfd",GradientType=1);
  }

  .chat-header {
    width: 100%;
    display: block;
    height: 75px;
    border-bottom: 2px solid rgba(0, 0, 0, 0.1);

    .big-button {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 10px;
      background-color: rgba(0, 0, 0, 0.05);
      padding: 10px;
      cursor: pointer;

      &:hover {
        background-color: rgba(0, 0, 0, 0.1);
      }
    }
  }

  .b-m-button {
    width: 100%;
    height: 100%;
    max-width: 60px;
    max-height: 60px;
    border-radius: 50%;
    background-color: #000000;
    padding: 15px;
    cursor: pointer;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 10px;

    display: flex;
    align-items: center;
    justify-content: center;

    img.b-m-button-icon {
      width: 100%;
      height: 100%;
      max-width: 40px;
      max-height: 40px;
      object-fit: scale-down;
      pointer-events: none;
      user-select: none;
    }
  }
</style>
